import { render, staticRenderFns } from "./Attribution.vue?vue&type=template&id=97e3b232"
import script from "./Attribution.vue?vue&type=script&lang=js"
export * from "./Attribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports